fx.ns("shared.screens", class ShapeAlbum extends shared.screens.BaseChoiceScreen
{
    constructor()
    {
        super();

        this.showNext = false;
        this.showBack = fx.get("mode") == "creating";

        this.styleChoice = "circle";

        this.containerHeight = 450;

        this.title = fx.text("Choisissez la forme de votre album");

        this.choices =  [];
    }
    
    create()
    {
        // the starting prices come from the cover options (format x cover rows) : when they
        // are not loaded yet, the choices are built once they are
        if (this.data.creation.coverChoices.length > 0)
            this._addChoices();

        super.create();

        if (this.choices.length == 0)
        {
            this.loading(true, fx.text("Chargement"));
            this.data.creation.coverChoices.load();
        }
    }

    onDataEvent(event)
    {
        if (event.type == "cover-option-loaded" && this.choices.length == 0)
        {
            this._addChoices();
            this.build();
            this.loading(false);
        }
    }

    _addChoices()
    {
        if (this.data.choosedCover != 6)
            this.choices.push({ data : models.ProductBook.SQUARE, asset : fx.get("assets").shapeSquare, name : fx.text("Carré"), price : this._startingPrice(models.ProductBook.SQUARE)});

        this.choices.push({ data : models.ProductBook.PORTRAIT, asset : fx.get("assets").shapePortrait, name : fx.text("Portrait"), price : this._startingPrice(models.ProductBook.PORTRAIT)});
        this.choices.push({ data : models.ProductBook.LANDSCAPE, asset : fx.get("assets").shapeLandscape, name : fx.text("Paysage"), price : this._startingPrice(models.ProductBook.LANDSCAPE)});
    }

    // "A partir de" : the cheapest album of that shape - with the cover the product fixed when
    // it did (stapled notebook, layflat album), otherwise any cover but the stapled one
    _startingPrice(shape)
    {
        let covers = this.data.creation.coverChoices;
        let fixed = this.data.choosedCover ? (isNaN(this.data.choosedCover) ? covers.getOptionId(this.data.choosedCover) : Number(this.data.choosedCover)) : 0;
        let bind = covers.getOptionId(models.ProductBook.BIND);
        let min = null;

        for (let i = 0; i < covers.length; i++)
        {
            let option = covers.getItemAt(i);

            if (!option.active || !option.format || option.format.style != shape)
                continue;

            if (fixed ? option.option_id != fixed : option.option_id == bind)
                continue;

            if (min === null || Number(option.price_base) < min)
                min = Number(option.price_base);
        }

        return min === null ? undefined : fx.text("A partir de <strong>$€</strong>", (min * fx.get("lang").tax).toFixed(2));
    }

    onChoiceClicked(data)
    {
        this.data.choosedShape = data;
        this.data.event("next-step");
    }
});